import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CRMItem } from '../../../../shared/models/crm/CRMItem.model';

@Component({
  selector: 'rms-email-leader-modal',
  templateUrl: './email-leader-modal.component.html',
  styleUrls: ['./email-leader-modal.component.scss'],
  standalone: false
})
export class EmailLeaderModalComponent implements OnInit {

  @Input() crmItem: CRMItem;

  public subject = '';
  public body = '';
  public leaderName = 'Leader';

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
    // Initialize with default subject if needed
    if (this.crmItem) {
      this.subject = `Regarding: ${this.crmItem.name}`;
      this.leaderName = this.crmItem.leader?.user?.fullName || 'Leader';
    }
  }

  submit() {
    if (this.isValid()) {
      this.activeModal.close({
        subject: this.subject,
        body: this.body
      });
    }
  }

  close() {
    this.activeModal.close(null);
  }

  isValid(): boolean {
    return this.subject.trim().length > 0 && this.body.trim().length > 0;
  }

}
